import React from 'react';
import blogCover from '../images/blog9.png';
import blogCover2 from '../images/blog16.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';
import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/why-businesses-choose-peregrinee"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function WhyBusinessesChoosePeregrinee() {

    const postDate = "March 10, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            Why Businesses Choose Peregrinee for Custom Software Development
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Discover how Peregrinee delivers scalable, secure, and future-ready
                        custom software solutions that help businesses innovate and grow faster.
                    </p>

                    {/* AUTHOR + DATE */}
                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>

            {/* HERO IMAGE */}
            <section className="container mb-5">
                <img
                    src={blogCover}
                    alt="Custom Software Development"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />
            </section>

            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">
                        <img
                            src={blogCover}
                            alt="Custom Software Development"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />
                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            Understanding Custom Software Development
                        </h3>

                        <p>
                            Custom software development focuses on building tailored digital
                            solutions that align precisely with a company’s operational needs,
                            workflows, and long-term goals. Unlike generic software,
                            custom systems provide flexibility, performance,
                            and full control over business processes.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Why Companies Trust Peregrinee
                        </h3>

                        <p>
                            Businesses choose Peregrinee because we combine technical expertise
                            with strategic business insight. Every solution is designed
                            to solve real operational challenges while maintaining
                            scalability and security.
                        </p>

                        <ul className="ps-3">
                            <li>Fully customized solutions aligned with business goals</li>
                            <li>Scalable architecture built for long-term growth</li>
                            <li>Secure development following modern best practices</li>
                            <li>Seamless integration with existing tools and systems</li>
                            <li>Ongoing support and performance optimization</li>
                        </ul>

                    </div>

                </div>

            </section>


            {/* INDUSTRIES */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Industries We Empower with Custom Software
                </h2>

                <p className="text-center text-muted mb-4">
                    Peregrinee delivers tailored software solutions across multiple industries.
                </p>

                <div className="row">

                    <div className="col-md-6">
                        <ul className="ps-3">
                            <li>Education & EdTech Platforms</li>
                            <li>Healthcare & HMS Systems</li>
                            <li>Enterprise & Corporate Operations</li>
                            <li>Finance & FinTech Solutions</li>
                            <li>Logistics & Supply Chain Management</li>
                        </ul>
                    </div>

                    <div className="col-md-6">
                        <ul className="ps-3">
                            <li>Retail & E-Commerce Platforms</li>
                            <li>Real Estate Management Systems</li>
                            <li>HRMS & Workforce Automation</li>
                            <li>SaaS Product Development</li>
                            <li>Custom ERP & CRM Solutions</li>
                        </ul>
                    </div>

                </div>

            </section>


            {/* TECHNOLOGY STACK */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Technology Stack & Scalable Architecture
                </h2>

                <p>
                    At Peregrinee, technology decisions are based on scalability,
                    performance, and long-term growth.
                </p>

                <ul className="ps-3">
                    <li>React / Next.js Frontend Development</li>
                    <li>Node.js / Python / Java Backend Systems</li>
                    <li>Secure Database Architecture</li>
                    <li>Cloud Infrastructure Deployment</li>
                    <li>API Integration & Microservices</li>
                </ul>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>

            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default WhyBusinessesChoosePeregrinee;